import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import {Typography} from '@customink/pigment-react';

const propTypes = {
  counter: PropTypes.string,
  options: PropTypes.object,
  preview: PropTypes.bool,
  project: PropTypes.object,
  step: PropTypes.string,
  stepTitle: PropTypes.string,
  stepValue: PropTypes.string,
  onClick: PropTypes.func
};

/**
 * This is still a wild, unoptimized, and confusing way to write two button toggle,
 * but it's better than how it was previously written as a custom function
 * with 5 positional arguments in the body of the OrderOptions component.
 * @param {typeof propTypes} props - Component properties.
 *
 * */
export default function OrderOption({
  preview,
  step,
  stepValue,
  stepTitle,
  options,
  counter,
  project,
  onClick
}) {
  return (
    <div className="ndx-OrderOptions-step">
      {!preview && (
        <Typography
          variant="heading5"
          data-testid="order-options-step-label"
          className="ndx-OrderOptions-step-label">
          {counter}. {stepTitle}
        </Typography>
      )}
      <div className="ndx-OrderOptions-step-options">
        {Object.keys(options).map((option, index) => {
          const className = classNames(
            'ndx-OrderOptions-step-option',
            'ndx-Button',
            {active: stepValue === option}
          );
          const isActive = stepValue === option;

          if (preview && option !== stepValue) {
            return null;
          } else {
            return (
              <button
                key={`${stepValue}-${index}`}
                className={className}
                disabled={
                  options[option].id === 'sizes_organizer' &&
                  project.payment === 'COMMUNITY'
                }
                onClick={() => onClick(option, step)}>
                <Typography
                  variant="uiTextSmall"
                  sx={isActive ? {fontWeight: 'bold'} : {}}>
                  {options[option].text}
                </Typography>
                <div className="checkmark-circle">
                  <div className="checkmark-stem" />
                  <div className="checkmark-kick" />
                </div>
              </button>
            );
          }
        })}
      </div>
    </div>
  );
}

OrderOption.propTypes = propTypes;
